module.exports = __webpack_public_path__ + "img/close-x.840667be.png";